import { SVGProps } from 'react';

const GitPullRequestCreate = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0 0v12m7-15h3a2 2 0 0 1 2 2v3m0 4v6m3-3h-6"
    />
  </svg>
);
export default GitPullRequestCreate;
